import React, { useEffect } from "react";
import { AutoTabProvider } from "react-auto-tab";
import { WithdrawButton, PinModalInput } from "./Withdraw.styled";
import { useDispatch, useSelector } from "react-redux";
import { withdraw } from "../../feature/withdraw/WithdrawActions";
import { useFormik } from "formik";
import { FormError } from "../Auth.styled";
import ReactLoading from "react-loading";
import { clearInputError } from "../../feature/inputError/inputErrorSlice";
import { clearMessage } from "../../feature/message/messageSlice";

const PinModal = (props) => {
  const dispatch = useDispatch();
  const { amount, withdrawal_address } = props;
  const { user } = useSelector((state) => state.user);
  const { loading } = useSelector((state) => state.withdraw);
  const { inputError } = useSelector((state) => state.inputError);
  const { showPinModal, setShowPinModal, setWithdrawn } = props;

  const onSubmit = (values) => {
    const pin = `${values.pin1}${values.pin2}${values.pin3}${values.pin4}${values.pin5}`;
    dispatch(
      withdraw({
        user: Object.keys(user).length && user.id,
        amount: amount,
        withdrawal_address: withdrawal_address,
        pin: pin,
      })
    )
      .unwrap()
      .then((res) => {
        setWithdrawn(true);
      });
  };

  const initialValues = {
    pin1: "",
    pin2: "",
    pin3: "",
    pin4: "",
    pin5: "",
  };

  const pinPlaceholder = "____";

  const formik = useFormik({
    initialValues,
    onSubmit,
  });

  useEffect(() => {
    dispatch(clearMessage());
    dispatch(clearInputError());
  }, [dispatch, user]);

  return (
    <div
      style={{
        display: `${showPinModal ? "flex" : "none"}`,
        flexDirection: "column",
        position: "fixed",
        width: "100vw",
        marginInline: "auto",
        top: 0,
        left: 0,
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div
        style={{
          background: "#000",
          border: "1px solid #7B36EE",
          borderRadius: "10px",
          marginInline: "15px",
          padding: "15px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "calc(100% - 60px)",
        }}
      >
        <div style={{ marginBlockEnd: "15px" }}>Confirm Address</div>
        <div>{withdrawal_address}</div>
      </div>
      <div
        style={{
          background: "#000",
          border: "1px solid #7B36EE",
          borderRadius: "10px",
          height: "300px",
          marginInline: "15px",
          padding: "15px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          onClick={() => setShowPinModal(false)}
          style={{ display: "flex", alignSelf: "self-end", cursor: "pointer" }}
        >
          X
        </div>
        <form style={{ marginBlock: "auto" }} onSubmit={formik.handleSubmit}>
          <h3 style={{ textAlign: "center" }}>Withdrawal Pin</h3>
          <AutoTabProvider
            style={{ display: "flex", justifyContent: "space-evenly" }}
          >
            <PinModalInput
              type="number"
              name="pin1"
              onChange={formik.handleChange}
              value={formik.values.pin1}
              maxLength={1}
              tabbable
              pattern="\d*"
              style={{ width: "10%", textAlign: "center", border: "none" }}
              placeholder={pinPlaceholder}
              autoFocus="on"
            />
            <PinModalInput
              type="number"
              name="pin2"
              onChange={formik.handleChange}
              value={formik.values.pin2}
              maxLength={1}
              tabbable
              pattern="\d*"
              style={{ width: "10%", textAlign: "center", border: "none" }}
              placeholder={pinPlaceholder}
            />
            <PinModalInput
              type="number"
              name="pin3"
              onChange={formik.handleChange}
              value={formik.values.pin3}
              maxLength={1}
              tabbable
              pattern="\d*"
              style={{ width: "10%", textAlign: "center", border: "none" }}
              placeholder={pinPlaceholder}
            />
            <PinModalInput
              type="number"
              name="pin4"
              onChange={formik.handleChange}
              value={formik.values.pin4}
              maxLength={1}
              tabbable
              pattern="\d*"
              style={{ width: "10%", textAlign: "center", border: "none" }}
              placeholder={pinPlaceholder}
            />
            <PinModalInput
              type="number"
              name="pin5"
              onChange={formik.handleChange}
              value={formik.values.pin5}
              maxLength={1}
              tabbable
              pattern="\d*"
              style={{ width: "10%", textAlign: "center", border: "none" }}
              placeholder={pinPlaceholder}
            />
          </AutoTabProvider>
          <WithdrawButton
            type="submit"
            disabled={loading}
            style={{ marginTop: "20px" }}
          >
            {loading ? (
              <ReactLoading
                type={"spinningBubbles"}
                height={"20px"}
                width={"20px"}
              />
            ) : (
              "Withdraw"
            )}
          </WithdrawButton>
          <FormError>
            {inputError !== undefined
              ? inputError.pin
                ? inputError.pin
                : null
              : null}
          </FormError>
          <FormError>
            {inputError !== undefined
              ? inputError.address_used
                ? inputError.address_used
                : null
              : null}
          </FormError>
          {/* <FormError>
            {inputError !== undefined ? (inputError ? inputError : null) : null}
          </FormError> */}
        </form>
      </div>
    </div>
  );
};

export default PinModal;
